import type React from 'react';
import { useIntl } from 'react-intl';
import { CarouselModal } from 'app/ui/components/molecules/carousel-modal/carousel-modal';
import type { CarouselModalConfig, CarouselSlide } from 'app/ui/components/molecules/carousel-modal/types';

interface PlansCarouselModalProps {
  maxShowTimes?: number;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  onStartPlan?: () => void | Promise<void>;
}

export const DEFAULT_MAX_SHOW_TIMES = 1;
export const PLANS_CAROUSEL_STORAGE_KEY = 'plans-carousel-shown-times';

export const PlansCarouselModal: React.FC<PlansCarouselModalProps> = ({
  maxShowTimes = DEFAULT_MAX_SHOW_TIMES,
  isOpen,
  onOpenChange,
  onStartPlan,
}) => {
  const intl = useIntl();

  const PLANS_SLIDES: CarouselSlide[] = [
    {
      imageUrl: 'https://images.prod.hyrox.fiit-tech.net/public/wPJ7qANxMvw22DQTNVwaqT.png',
      title: intl.formatMessage({ id: 'trainingPlansOnboarding.slide1.title' }),
      description: intl.formatMessage({ id: 'trainingPlansOnboarding.slide1.description' }),
    },
    {
      imageUrl: 'https://images.prod.hyrox.fiit-tech.net/public/gFdu8sj3vACuHrx2PcPHXW.png',
      title: intl.formatMessage({ id: 'trainingPlansOnboarding.slide2.title' }),
      description: intl.formatMessage({ id: 'trainingPlansOnboarding.slide2.description' }),
    },
    {
      imageUrl: 'https://images.prod.hyrox.fiit-tech.net/public/nB4Z8ei23n54qb4M2qsyXA.png',
      title: intl.formatMessage({ id: 'trainingPlansOnboarding.slide3.title' }),
      description: intl.formatMessage({ id: 'trainingPlansOnboarding.slide3.description' }),
    },
    {
      imageUrl: 'https://images.prod.hyrox.fiit-tech.net/public/7ZspYDZZMihGGnKUqvULyy.png',
      title: intl.formatMessage({ id: 'trainingPlansOnboarding.slide4.title' }),
      description: intl.formatMessage({ id: 'trainingPlansOnboarding.slide4.description' }),
    },
    {
      imageUrl: 'https://images.prod.hyrox.fiit-tech.net/public/mcFb9VDzWGYhetCjAwMPEf.png',
      title: intl.formatMessage({ id: 'trainingPlansOnboarding.slide5.title' }),
      description: intl.formatMessage({ id: 'trainingPlansOnboarding.slide5.description' }),
    },
  ];

  const PLANS_CAROUSEL_CONFIG: CarouselModalConfig = {
    slides: PLANS_SLIDES,
    storageKey: PLANS_CAROUSEL_STORAGE_KEY,
    maxShowTimes,
    disableOnMobile: false,
  };

  return (
    <CarouselModal
      config={PLANS_CAROUSEL_CONFIG}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onFinalAction={onStartPlan}
    />
  );
};
